module.exports = __webpack_public_path__ + "static/media/dropdown_icon.7a7bd13a.svg";